/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const updateAthlete = /* GraphQL */ `
  mutation UpdateAthlete(
    $input: UpdateAthleteInput!
    $condition: ModelAthleteConditionInput
  ) {
    updateAthlete(input: $input, condition: $condition) {
      id
      clubID
      schoolID
      first_name
      last_name
      email
      middle_name
      address
      parish
      dob
      nrid
      gender
      country
      nationality
      home
      mobile
      medical
      medical_treatment1
      medical_treatment2
      medical_treatment3
      medical_treatment4
      medical_treatment5
      medications1
      medications2
      medications3
      medications4
      medications5
      supplements1
      supplements2
      supplements3
      supplements4
      supplements5
      alt_email
      photo_url
      waiver_url
      shirt_size
      pants_size
      shoe_size
      sig_waiver
      sig_antidope
      sig_authorize
      club_verified
      aab_verified
      fees_paid
      createdAt
      updatedAt
      club {
        id
        name
        aab_verified
        organization_type
        createdAt
        updatedAt
        athletes {
          nextToken
        }
        school_athletes {
          nextToken
        }
        coaches {
          nextToken
        }
      }
      school {
        id
        name
        aab_verified
        organization_type
        createdAt
        updatedAt
        athletes {
          nextToken
        }
        school_athletes {
          nextToken
        }
        coaches {
          nextToken
        }
      }
    }
  }
`;
export const deleteAthlete = /* GraphQL */ `
  mutation DeleteAthlete(
    $input: DeleteAthleteInput!
    $condition: ModelAthleteConditionInput
  ) {
    deleteAthlete(input: $input, condition: $condition) {
      id
      clubID
      schoolID
      first_name
      last_name
      email
      middle_name
      address
      parish
      dob
      nrid
      gender
      country
      nationality
      home
      mobile
      medical
      medical_treatment1
      medical_treatment2
      medical_treatment3
      medical_treatment4
      medical_treatment5
      medications1
      medications2
      medications3
      medications4
      medications5
      supplements1
      supplements2
      supplements3
      supplements4
      supplements5
      alt_email
      photo_url
      waiver_url
      shirt_size
      pants_size
      shoe_size
      sig_waiver
      sig_antidope
      sig_authorize
      club_verified
      aab_verified
      fees_paid
      createdAt
      updatedAt
      club {
        id
        name
        aab_verified
        organization_type
        createdAt
        updatedAt
        athletes {
          nextToken
        }
        school_athletes {
          nextToken
        }
        coaches {
          nextToken
        }
      }
      school {
        id
        name
        aab_verified
        organization_type
        createdAt
        updatedAt
        athletes {
          nextToken
        }
        school_athletes {
          nextToken
        }
        coaches {
          nextToken
        }
      }
    }
  }
`;
export const createClub = /* GraphQL */ `
  mutation CreateClub(
    $input: CreateClubInput!
    $condition: ModelClubConditionInput
  ) {
    createClub(input: $input, condition: $condition) {
      id
      name
      aab_verified
      organization_type
      createdAt
      updatedAt
      athletes {
        items {
          id
          clubID
          schoolID
          first_name
          last_name
          email
          middle_name
          address
          parish
          dob
          nrid
          gender
          country
          nationality
          home
          mobile
          medical
          medical_treatment1
          medical_treatment2
          medical_treatment3
          medical_treatment4
          medical_treatment5
          medications1
          medications2
          medications3
          medications4
          medications5
          supplements1
          supplements2
          supplements3
          supplements4
          supplements5
          alt_email
          photo_url
          waiver_url
          shirt_size
          pants_size
          shoe_size
          sig_waiver
          sig_antidope
          sig_authorize
          club_verified
          aab_verified
          fees_paid
          createdAt
          updatedAt
        }
        nextToken
      }
      school_athletes {
        items {
          id
          clubID
          schoolID
          first_name
          last_name
          email
          middle_name
          address
          parish
          dob
          nrid
          gender
          country
          nationality
          home
          mobile
          medical
          medical_treatment1
          medical_treatment2
          medical_treatment3
          medical_treatment4
          medical_treatment5
          medications1
          medications2
          medications3
          medications4
          medications5
          supplements1
          supplements2
          supplements3
          supplements4
          supplements5
          alt_email
          photo_url
          waiver_url
          shirt_size
          pants_size
          shoe_size
          sig_waiver
          sig_antidope
          sig_authorize
          club_verified
          aab_verified
          fees_paid
          createdAt
          updatedAt
        }
        nextToken
      }
      coaches {
        items {
          id
          clubID
          first_name
          last_name
          userId
          email
          middle_name
          address
          parish
          home
          mobile
          aab_verified
          fees_paid
          createdAt
          updatedAt
          owner
        }
        nextToken
      }
    }
  }
`;
export const updateClub = /* GraphQL */ `
  mutation UpdateClub(
    $input: UpdateClubInput!
    $condition: ModelClubConditionInput
  ) {
    updateClub(input: $input, condition: $condition) {
      id
      name
      aab_verified
      organization_type
      createdAt
      updatedAt
      athletes {
        items {
          id
          clubID
          schoolID
          first_name
          last_name
          email
          middle_name
          address
          parish
          dob
          nrid
          gender
          country
          nationality
          home
          mobile
          medical
          medical_treatment1
          medical_treatment2
          medical_treatment3
          medical_treatment4
          medical_treatment5
          medications1
          medications2
          medications3
          medications4
          medications5
          supplements1
          supplements2
          supplements3
          supplements4
          supplements5
          alt_email
          photo_url
          waiver_url
          shirt_size
          pants_size
          shoe_size
          sig_waiver
          sig_antidope
          sig_authorize
          club_verified
          aab_verified
          fees_paid
          createdAt
          updatedAt
        }
        nextToken
      }
      school_athletes {
        items {
          id
          clubID
          schoolID
          first_name
          last_name
          email
          middle_name
          address
          parish
          dob
          nrid
          gender
          country
          nationality
          home
          mobile
          medical
          medical_treatment1
          medical_treatment2
          medical_treatment3
          medical_treatment4
          medical_treatment5
          medications1
          medications2
          medications3
          medications4
          medications5
          supplements1
          supplements2
          supplements3
          supplements4
          supplements5
          alt_email
          photo_url
          waiver_url
          shirt_size
          pants_size
          shoe_size
          sig_waiver
          sig_antidope
          sig_authorize
          club_verified
          aab_verified
          fees_paid
          createdAt
          updatedAt
        }
        nextToken
      }
      coaches {
        items {
          id
          clubID
          first_name
          last_name
          userId
          email
          middle_name
          address
          parish
          home
          mobile
          aab_verified
          fees_paid
          createdAt
          updatedAt
          owner
        }
        nextToken
      }
    }
  }
`;
export const deleteClub = /* GraphQL */ `
  mutation DeleteClub(
    $input: DeleteClubInput!
    $condition: ModelClubConditionInput
  ) {
    deleteClub(input: $input, condition: $condition) {
      id
      name
      aab_verified
      organization_type
      createdAt
      updatedAt
      athletes {
        items {
          id
          clubID
          schoolID
          first_name
          last_name
          email
          middle_name
          address
          parish
          dob
          nrid
          gender
          country
          nationality
          home
          mobile
          medical
          medical_treatment1
          medical_treatment2
          medical_treatment3
          medical_treatment4
          medical_treatment5
          medications1
          medications2
          medications3
          medications4
          medications5
          supplements1
          supplements2
          supplements3
          supplements4
          supplements5
          alt_email
          photo_url
          waiver_url
          shirt_size
          pants_size
          shoe_size
          sig_waiver
          sig_antidope
          sig_authorize
          club_verified
          aab_verified
          fees_paid
          createdAt
          updatedAt
        }
        nextToken
      }
      school_athletes {
        items {
          id
          clubID
          schoolID
          first_name
          last_name
          email
          middle_name
          address
          parish
          dob
          nrid
          gender
          country
          nationality
          home
          mobile
          medical
          medical_treatment1
          medical_treatment2
          medical_treatment3
          medical_treatment4
          medical_treatment5
          medications1
          medications2
          medications3
          medications4
          medications5
          supplements1
          supplements2
          supplements3
          supplements4
          supplements5
          alt_email
          photo_url
          waiver_url
          shirt_size
          pants_size
          shoe_size
          sig_waiver
          sig_antidope
          sig_authorize
          club_verified
          aab_verified
          fees_paid
          createdAt
          updatedAt
        }
        nextToken
      }
      coaches {
        items {
          id
          clubID
          first_name
          last_name
          userId
          email
          middle_name
          address
          parish
          home
          mobile
          aab_verified
          fees_paid
          createdAt
          updatedAt
          owner
        }
        nextToken
      }
    }
  }
`;
export const updateCoach = /* GraphQL */ `
  mutation UpdateCoach(
    $input: UpdateCoachInput!
    $condition: ModelCoachConditionInput
  ) {
    updateCoach(input: $input, condition: $condition) {
      id
      clubID
      first_name
      last_name
      userId
      email
      middle_name
      address
      parish
      home
      mobile
      aab_verified
      fees_paid
      createdAt
      updatedAt
      club {
        id
        name
        aab_verified
        organization_type
        createdAt
        updatedAt
        athletes {
          nextToken
        }
        school_athletes {
          nextToken
        }
        coaches {
          nextToken
        }
      }
      owner
    }
  }
`;
export const deleteCoach = /* GraphQL */ `
  mutation DeleteCoach(
    $input: DeleteCoachInput!
    $condition: ModelCoachConditionInput
  ) {
    deleteCoach(input: $input, condition: $condition) {
      id
      clubID
      first_name
      last_name
      userId
      email
      middle_name
      address
      parish
      home
      mobile
      aab_verified
      fees_paid
      createdAt
      updatedAt
      club {
        id
        name
        aab_verified
        organization_type
        createdAt
        updatedAt
        athletes {
          nextToken
        }
        school_athletes {
          nextToken
        }
        coaches {
          nextToken
        }
      }
      owner
    }
  }
`;
export const createAthlete = /* GraphQL */ `
  mutation CreateAthlete(
    $input: CreateAthleteInput!
    $condition: ModelAthleteConditionInput
  ) {
    createAthlete(input: $input, condition: $condition) {
      id
      clubID
      schoolID
      first_name
      last_name
      email
      middle_name
      address
      parish
      dob
      nrid
      gender
      country
      nationality
      home
      mobile
      medical
      medical_treatment1
      medical_treatment2
      medical_treatment3
      medical_treatment4
      medical_treatment5
      medications1
      medications2
      medications3
      medications4
      medications5
      supplements1
      supplements2
      supplements3
      supplements4
      supplements5
      alt_email
      photo_url
      waiver_url
      shirt_size
      pants_size
      shoe_size
      sig_waiver
      sig_antidope
      sig_authorize
      club_verified
      aab_verified
      fees_paid
      createdAt
      updatedAt
      club {
        id
        name
        aab_verified
        organization_type
        createdAt
        updatedAt
        athletes {
          nextToken
        }
        school_athletes {
          nextToken
        }
        coaches {
          nextToken
        }
      }
      school {
        id
        name
        aab_verified
        organization_type
        createdAt
        updatedAt
        athletes {
          nextToken
        }
        school_athletes {
          nextToken
        }
        coaches {
          nextToken
        }
      }
    }
  }
`;
export const createCoach = /* GraphQL */ `
  mutation CreateCoach(
    $input: CreateCoachInput!
    $condition: ModelCoachConditionInput
  ) {
    createCoach(input: $input, condition: $condition) {
      id
      clubID
      first_name
      last_name
      userId
      email
      middle_name
      address
      parish
      home
      mobile
      aab_verified
      fees_paid
      createdAt
      updatedAt
      club {
        id
        name
        aab_verified
        organization_type
        createdAt
        updatedAt
        athletes {
          nextToken
        }
        school_athletes {
          nextToken
        }
        coaches {
          nextToken
        }
      }
      owner
    }
  }
`;
